<template>
  <div>
    <Area
      :info-card="computedInfoCard"
      :data-series="computedTrafficSeries"
      custom-cached-data-name="Cached data ratio"
      custom-non-cached-data-name="Non-cached data ratio"
      :time-stamps="timeStamps"
      :format-percentage="false"
    />
    <div
      class="my-1 col-lg-12 col-12 d-flex flex-wrap px-0 mx-0"
    >
      <div class="col-lg-4 col-md-6 col-12 pl-0 ">
        <SimpleDonutChart
          :cached-data="trafficCachedData.number || 0"
          :no-cached-data="trafficNoCacheData.number || 0"
          :loading-donut-data="trafficLoaded"
          :colors="['#619AF8', '#F2A342']"
        />
      </div>
      <div class="col-lg-8 col-md-6 col-12 px-0">
        <traffic-time
          class="xs-mt-1"
          icon-name="Info"
          icon-color="text-secondary"
          info-title="Information"
          info-title-class="text-main"
          :description="description"
          :time-stamps="trafficTimeStamps"
          :series="processedSeries"
          :total-traffic="extractedTotalsTrafficTime"
          description-class="text-secondary text-bold"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Area from '../widgets/Area.vue'
import SimpleDonutChart from '../widgets/SimpleDonutChart.vue'
import TrafficTime from '../widgets/TrafficTime.vue'

export default {
  components: {
    Area,
    SimpleDonutChart,
    TrafficTime,
  },
  data() {
    return {
      description: [
        {
          id: 1,
          description: 'Cached ratio is a percentage value between cache hits and cache misses. The higher your cached ratio is, the faster is the data delivery.',
        },
        {
          id: 2,
          description: 'For websites with static content, it\'s typical to have a 90% and higher cached ratio.   For dynamic websites, where content changes frequently, the cached ratio will be slightly lower.',
        },
        {
          id: 3,
          description: 'If your cached ratio is lower than 70%, feel free to <a href="https://www.google.com">contact our support team</a> so they can help you with the optimization.',
        },
      ],
    }
  },
  computed: {
    traffic() {
      return this.$store.state.analytics.traffic
    },
    trafficLoaded() {
      return this.$store.state.analytics.loadingTraffic
    },
    trafficCachedData() {
      return this.$store.state.analytics.trafficCachedData
    },
    trafficNoCacheData() {
      return this.$store.state.analytics.trafficNoCacheData
    },
    computedInfoCard() {
      const infoCard = [
        {
          id: 1,
          title: 'Cached data ratio',
          description: this.trafficCachedData.percentValue,
          elipseColor: '#3A81F6',
          loading: this.trafficLoaded,
        },
        {
          id: 2,
          title: 'Non-Cached data ratio',
          description: this.trafficNoCacheData.percentValue,
          elipseColor: '#F2A342',
          loading: this.trafficLoaded,

        },
      ]
      return infoCard
    },
    computedTrafficSeries() {
      return this.getTrafficSeries(this.traffic[0]?.result)
    },
    processedSeries() {
      return this.processData(this.traffic)
    },
    timeStamps() {
      if (this.computedTrafficSeries && this.computedTrafficSeries.length > 0) {
        return this.formatTimestamps(this.computedTrafficSeries[0])
      }
      return null
    },
    extractedTotalsTrafficTime() {
      return this.extractTotals(this.traffic)
    },
    trafficTimeStamps() {
      if (this.extractedTotalsTrafficTime && this.extractedTotalsTrafficTime.length > 0) {
        return this.formatTimestamps(this.extractedTotalsTrafficTime[0])
      }
      return null
    },
  },
  methods: {
    getTrafficSeries(dataList) {
      const names = ['sizeCached', 'sizeNonCached']
      const result = dataList?.filter(item => names?.includes(item.name))
        .map(item => ({
          name: item.name === names[0] ? 'Cached size' : 'Non-cached size',
          data: item?.data?.map(data => data?.value),
          timestamps: item?.data?.map(data => data?.timestamp),
          total: item.total,
        }))
      return result
    },
    formatTimestamps(data) {
      if (!data.timestamps) return []

      return data.timestamps.map(timestamp => parseInt(timestamp, 10))
    },
    extractTotals(data) {
      return [{
        name: 'totalTraffic',
        data: data?.map(entry => entry?.total),
        timestamps: data?.map(entry => entry?.peak_Time),
      }]
    },
    processData(data) {
      const cachedData = []
      const nonCachedData = []

      data.forEach(entry => {
        const sizeCachedResult = entry.result.find(result => result.name === 'sizeCached')
        const sizeNonCachedResult = entry.result.find(result => result.name === 'sizeNonCached')

        if (sizeCachedResult) {
          cachedData.push(sizeCachedResult.total)
        }

        if (sizeNonCachedResult) {
          nonCachedData.push(sizeNonCachedResult.total)
        }
      })

      const series = [
        {
          name: 'Cached Data',
          data: cachedData,
        },
        {
          name: 'Non Cached Data',
          data: nonCachedData,
        },
      ]

      return series
    },
  },
}
</script>
